var map = {
	"./banner/routes.js": "e1ce",
	"./comment/routes.js": "5431",
	"./magazine/routes.js": "dbae",
	"./puzzle/routes.js": "ca81",
	"./settings/routes.js": "de76",
	"./user/routes.js": "2e02"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "74855";